angular.module('omfm').service('Labels', InboxLabelsService);

InboxLabelsService.$inject = ['$resource', 'ServerInterceptor'];

function InboxLabelsService($resource, ServerInterceptor) {
	return $resource('/labels', {"id": "@id"}, {
		'list': {
			'url': "/admin/labels/list",
			'method': 'get',
			'interceptor': ServerInterceptor,
			'isArray': true
		},
		'add':{
			'url': "/admin/labels/add",
			'method': 'post',
			'interceptor': ServerInterceptor,
		}
	})
}